import React, { useRef, useState } from 'react';

import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  MixedGridGroup,
  Text,
  Label,
  QuantaInput,
  QuantaButton,
  QuantaInputWrapper,
  QuantaCheckbox,
  InputGridGroup,
} from 'quanta-ui';
import { faSearch,faSpinner,faExclamation,faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@apollo/client';
import { GET_BUY_HEALTH_POLICY_VAR_DETAILS } from '../queries';
import { VEHICLE_DETAILS } from '../queries';
import {Loading} from 'quanta-flows/modules/layout';
//import Parse from '../../../../../lib/intl/CurrencyFormater';
import { useEffect } from 'react';
import { CurrencyFormater } from 'quanta-flows';
//import { updateBuyHealthPolicy } from '../_graphqlscpa/state';
import { updateBuyHealthPolicy } from 'quanta-flows/modules/proposal/health/state';
import { RTO_LIST_BRAND_LIST_YEAR_RANGE,MODEL_DETAILS } from '../queries';
import { useFetchCacheQuery } from 'quanta-flows/modules/index';
//import { b } from 'quanta-flows/modules/_rollupPluginBabelHelpers-fb970440';
export default function VehicleDetails({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  lobCode,
  lobName,
  productCode,
  productType,
  productName,
  renderExpandedCards,
  ...props
}) {
  const repeatForMobile = 2,
    repeatForDesktop = 3;
  const repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  
  const initLoadRef = useRef([]);
  const fetchQuery = useFetchCacheQuery();
  const {
    loading: loadingBuyPolicy,
    error: errorBuyPolicy,
    data: dataBuyPolicy,
    previousData,
  } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: new Set(initLoadRef?.current).size >= 1 ? true : false,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });

  if (loadingBuyPolicy) {
    return (
      <div className="min-h-screen">
        <Loading customMessage={'Fetching Vehicle Details'} />
      </div>
    );
  }
  if (errorBuyPolicy) {
    return (
      <div className="min-h-screen">
        <Error error={errorBuyPolicy} />
      </div>
    );
  }
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };
  const buyMotorPolicy  = dataBuyPolicy
    ? dataBuyPolicy
    : previousData;
    const [makeList, setMakeList] = useState([]);
    const [modelList, setModelList] = useState([]);

    const [makeList1, setMakeList1] = useState([]);
    const [modelList1, setModelList1] = useState([]);

    const [makeList2, setMakeList2] = useState([]);
    const [modelList2, setModelList2] = useState([]);

    const [makeList3, setMakeList3] = useState([]);
    const [modelList3, setModelList3] = useState([]);

    const [makeList4, setMakeList4] = useState([]);
    const [modelList4, setModelList4] = useState([]);
    //3152 -two wheeler
    const [loadingVehicleDetials, setLoadingVehicleDetials] =
      useState(false);
        const getRtoDetails = async () => {
          try {
            const rtoBrandYearQuery = fetchQuery({
              query: RTO_LIST_BRAND_LIST_YEAR_RANGE,
              variables: {
                filterRTOList: {
                  rtoLocationCode: '',
                  rtoLocationDesc:  '',
                  imdCode:'',
                  productCode: 3152,
                },
                filterMakeList: { productCode: 3152 },
                type: 'Year of Manufacture',
              },
            });
            const { data:datab } = await rtoBrandYearQuery;
            setMakeList(datab?.makeList);
          } catch (error) {
            console.log('error',error)
          }
        };
    //3121 - private car
        const getRtoDetails1 = async () => {
          try {
            const rtoBrandYearQuery = fetchQuery({
              query: RTO_LIST_BRAND_LIST_YEAR_RANGE,
              variables: {
                filterRTOList: {
                  rtoLocationCode: '',
                  rtoLocationDesc:  '',
                  imdCode:'',
                  productCode: 3121,
                },
                filterMakeList: { productCode: 3121 },
                type: 'Year of Manufacture',
              },
            });
            const { data:datac } = await rtoBrandYearQuery;
            setMakeList1(datac?.makeList);
          } catch (error) {
          }
        };
    //3137 -  GCV
    const getRtoDetails2 = async () => {
      try {
        const rtoBrandYearQuery = fetchQuery({
          query: RTO_LIST_BRAND_LIST_YEAR_RANGE,
          variables: {
            filterRTOList: {
              rtoLocationCode: '',
              rtoLocationDesc:  '',
              imdCode:'',
              productCode: 3137,
            },
            filterMakeList: { productCode: 3137 },
            type: 'Year of Manufacture',
          },
        });
        const { data:datad } = await rtoBrandYearQuery;
        
        setMakeList2(datad?.makeList);
      } catch (error) {
        
        //console.log('data model error',error)
      }
    };
    const getRtoDetails3 = async () => {
      try {
        const rtoBrandYearQuery = fetchQuery({
          query: RTO_LIST_BRAND_LIST_YEAR_RANGE,
          variables: {
            filterRTOList: {
              rtoLocationCode: '',
              rtoLocationDesc:  '',
              imdCode:'',
              productCode: 3183,
            },
            filterMakeList: { productCode: 3183 },
            type: 'Year of Manufacture',
          },
        });
        const { data:datad } = await rtoBrandYearQuery;
        
        setMakeList3(datad?.makeList);
      } catch (error) {
        //console.log('data model error',error)
      }
    };
    const getRtoDetails4 = async () => {
      try {
        const rtoBrandYearQuery = fetchQuery({
          query: RTO_LIST_BRAND_LIST_YEAR_RANGE,
          variables: {
            filterRTOList: {
              rtoLocationCode: '',
              rtoLocationDesc:  '',
              imdCode:'',
              productCode: 3128,
            },
            filterMakeList: { productCode: 3128 },
            type: 'Year of Manufacture',
          },
        });
        const { data:datad } = await rtoBrandYearQuery;
        
        ////console.log('100_dataGCV',datad)
        setMakeList4(datad?.makeList);
        ////console.log('121_make list2',makeList4)
      } catch (error) {
        
        //console.log('data model error',error)
      }
    };
     
      
      //3152 - two wheeler
const onBrandSelected = async (val) => {
        //console.log('113 make');
        try {
          //console.log('115 make');
          
          const vehicleModelquery = fetchQuery({
            query: MODEL_DETAILS,
            variables: {
              filter: {
              productCode : 3152,
              makeCode: getDomainData(
                makeList,
                val?.toString(),
                'value',
                'code',
              ),
              //20571
              },
            },
          });
          
          const { data:data1 } = await vehicleModelquery;
          setModelList(data1?.modelList);
          //console.log('183 modelList', data1?.modelList);
          if (data1?.modelList?.length === 0) {
            //console.log('errorModelData1')
          } else {
            //console.log('errorModelData2')
          }
          return data1?.modelList
        } catch (error) {
          
          //console.log('errorModelData3',error)
        }
      
    };
    //3121 - private car
    const onBrandSelected1 = async (val) => {
      ////console.log('232 make',val);
      try {
        // //console.log('234 make',getDomainData(
        //   makeList1,
        //   val?.toString(),
        //   'value',
        //   'code',
        // ));
        
        const vehicleModelquery = fetchQuery({
          query: MODEL_DETAILS,
          variables: {
            filter: {
            productCode : 3121,
            makeCode: getDomainData(
              makeList1,
              val?.toString(),
              'value',
              'code',
            ),
            //20571
            },
          },
        });
        //console.log('219 make');
        const { data:data2 } = await vehicleModelquery;
        //console.log('219_data2',data2)
        setModelList1(data2?.modelList);
        //console.log('220 modelList', data2?.modelList);
        if (data2?.modelList?.length === 0) {
          //console.log('errorModelData1')
        } else {
          //console.log('errorModelData2')
        }
        return data2?.modelList
      } catch (error) {
        
        //console.log('errorModelData3',error)
      }
    
  };
  //3137 -  GCV
  const onBrandSelected2 = async (val) => {
    //console.log('270 make',val);
    try {
      // //console.log('272 make',getDomainData(
      //   makeList2,
      //   val?.toString(),
      //   'value',
      //   'code',
      // ));
      
      const vehicleModelquery = fetchQuery({
        query: MODEL_DETAILS,
        variables: {
          filter: {
          productCode : 3137,
          makeCode: getDomainData(
            makeList2,
            val?.toString(),
            'value',
            'code',
          ),
          //20571
          },
        },
      });
      //console.log('3183 make');
      const { data:data3 } = await vehicleModelquery;
      //console.log('285_data3',data3)
      setModelList2(data3?.modelList);
      //console.log('287 modelList', data3?.modelList);
      if (data3?.modelList?.length === 0) {
        //console.log('errorModelData1')
      } else {
        //console.log('errorModelData2')
      }
      return data3?.modelList
    } catch (error) {
      
      //console.log('307_errorModelData3',error)
    }
  
};
const onBrandSelected3 = async (val) => {
  //console.log('270 make',val);
  try {
    // //console.log('272 make',getDomainData(
    //   makeList3,
    //   val?.toString(),
    //   'value',
    //   'code',
    // ));
    
    const vehicleModelquery = fetchQuery({
      query: MODEL_DETAILS,
      variables: {
        filter: {
        productCode : 3183,
        makeCode: getDomainData(
          makeList3,
          val?.toString(),
          'value',
          'code',
        ),
        //20571
        },
      },
    });
    ////console.log('3183 make');
    const { data:data3 } = await vehicleModelquery;
    ////console.log('285_data3',data3)
    setModelList3(data3?.modelList);
    ////console.log('287 modelList', data3?.modelList);
    if (data3?.modelList?.length === 0) {
      //console.log('errorModelData1')
    } else {
      //console.log('errorModelData2')
    }
    return data3?.modelList
  } catch (error) {
    
    //console.log('307_errorModelData3',error)
  }

};
const onBrandSelected4 = async (val) => {
  //console.log('270 make',val);
  try {
    // //console.log('272 make',getDomainData(
    //   makeList4,
    //   val?.toString(),
    //   'value',
    //   'code',
    // ));
    
    const vehicleModelquery = fetchQuery({
      query: MODEL_DETAILS,
      variables: {
        filter: {
        productCode : 3128,
        makeCode: getDomainData(
          makeList4,
          val?.toString(),
          'value',
          'code',
        ),
        //20571
        },
      },
    });
    ////console.log('3183 make');
    const { data:data3 } = await vehicleModelquery;
    ////console.log('285_data3',data3)
    setModelList4(data3?.modelList);
    ////console.log('287 modelList', data3?.ModelList4);
    if (data3?.modelList?.length === 0) {
      //console.log('errorModelData1')
    } else {
      ////console.log('errorModelData2')
    }
    return data3?.modelList
  } catch (error) {
    
    //console.log('307_errorModelData3',error)
  }

};
//1
// const {
//   loading: loadingRto,
//   error: errorRto,
//   data: dataRto,
// } = useQuery(RTO_LIST_BRAND_LIST_YEAR_RANGE);
// //console.log('dataRto',dataRto)
const  buyHealthPolicy  = dataBuyPolicy
  ? dataBuyPolicy
  : previousData;
  //console.log('269_buyHealthPolicy',buyHealthPolicy)
const { quoteData,...restdata } = buyHealthPolicy?.buyHealthPolicy;
const { insuredDetails } = buyHealthPolicy?.buyHealthPolicy;
//console.log('quote data',quoteData);
const onFLALookup = async ( data,typevalue ,setFieldValue ) => {
  //console.log('FLA Values',data)
  const { vehicleRegNo } = data;
  const { part1, part2, part3, part4 } = vehicleRegNo;
  //console.log('typevalue',typevalue)
  let vehtype = typevalue.substring(2)
  //console.log('vehtype value-----',vehtype)
    //setFieldValue('regNo', `${part1}${part2}${part3}${part4}`);
    if (
      part1?.length === 2 &&
      part2?.length === 2 &&
      // part3?.length === 2 &&
      (part3?.length >= 1 && part3?.length <=3) &&
      part4?.length === 4
    ) {
      //console.log('FLA if')
      try {
        //console.log('FLA if try')
        //setErrorFLADetails(null);
        const flaDetails = fetchQuery({
          query: VEHICLE_DETAILS,
          fetchPolicy: 'network-only',
          variables: {
            input: {
              regNo: `${part1}${part2}${part3}${part4}`,
              rtoAuthCode: `${part1}${part2}`,
              //Type:`${vehtype}`
            },
          },
        });
        setLoadingVehicleDetials(true);
        //console.log('at true')
        const { data } = await flaDetails;
        //console.log('at false')
        setLoadingVehicleDetials(false);
        //console.log('output fla data',data)
        const { getVehicleDetails } = data;
        const {
          make,
          model,
          variant,
          fuelType,
          seatingCapacity,
          cubicCapacity,
          carryingCapacity,
          rto,
          manufactureYear,
          regPurchaseDate,
          engineNumber,
          chasisNumber,
          financerName,
          prevInsurance,
        } = getVehicleDetails;
        setFieldValue(
          `${typevalue}.VehicleMake`,
          make.value,
        );
        setFieldValue(
          `${typevalue}.VehicleModel`,
          model.value,
        );
        setFieldValue(
          `${typevalue}.EngineNo`,
          engineNumber,
        );
        setFieldValue(
          `${typevalue}.ChasisNo`,
          chasisNumber,
        );
        setFieldValue(
          `${typevalue}.isRegNoVerified`,
          true,
        );
      } 
      catch (error) {
        //console.log('at false',error)
        let count = 1
        // setFieldValue(
        //   `${typevalue}.fla`,
        //   error,
        // );
        setFieldValue(
          `${typevalue}.isRegNoVerified`,
          false,
        );
        setLoadingVehicleDetials(false);
        return count
        //setFieldValue(`anyPreviousPolicyforVehicleTaken`, 'No');
        
        //setFieldValue( `policyExpiryDate`,'',);
        
      }
    }
  
};
// const getInitObject = () => {
//   let initObj = {}

//     for(let i =0 ; i < quoteData.VehicleType.length ; i++){
//       initObj[quoteData?.VehicleType[i]] = {
//         RegistrationNumber : values.RegistrationNumber[i],
//         VehicleMakeModel :values.VehicleMake[i]+'-'+ values.VehicleModel[i],
//         EngineNo : values.EngineNo[i],
//         ChasisNo : values.ChasisNo[i],
//         ChasisNo : buyHealthPolicy?.buyHealthPolicy
//         ?.insuredDetails?.[i]?.ChasisNo
//         ? `${buyHealthPolicy?.buyHealthPolicy?.insuredDetails?.[i]?.ChasisNo}`
//         : '',
//       }
//   }
//   //console.log("initObj ",initObj);
//   return initObj;
// }

const getInitObject = () => {
  let initObj = {};
  //console.log("510 inside getinitobj :insuredDetails :",insuredDetails);
  if(insuredDetails.length !== 0)
  {//console.log('514 _on if')
  insuredDetails?.forEach((insured) => {
    initObj[insured.relationship] = {
      vehicleRegNo : {
        part1:insured?.vehicleRegNo?.part1
              ? insured?.vehicleRegNo?.part1
              : '',
        part2:insured?.vehicleRegNo?.part2
              ? insured?.vehicleRegNo?.part2
              : '',
        part3:insured?.vehicleRegNo?.part3
              ? insured?.vehicleRegNo?.part3
              : '',
        part4:insured?.vehicleRegNo?.part4
              ? insured?.vehicleRegNo?.part4
              : '',
      },
      RegistrationNumber : insured.RegistrationNumber
                          ? insured.RegistrationNumber
                          : '',
      isRegNoVerified : insured.VehicleMake
      ? insured.VehicleMake
      : '',

      VehicleMake : insured.VehicleMake
                          ? insured.VehicleMake
                          : '',
      VehicleModel : insured.VehicleModel
                          ? insured.VehicleModel
                          : '',
      EngineNo : insured.EngineNo
                          ? insured.EngineNo
                          : '',
      ChasisNo : insured.ChasisNo
                          ? insured.ChasisNo
                          : '',
    }
  });
}
  
  return initObj;
}
const initialValues = getInitObject();
//console.log("635_initialValues ",initialValues);
  //getInitObject();
  //const { quoteData } = buyMotorPolicy;
//console.log('dataBuyPolicyq---',quoteData)


useEffect(() => {
  // const vehdata = submitInsuredArr()
  // //console.log('vehdata--',vehdata)
    renderExpandedCards.current = [
      ...renderExpandedCards?.current,
      ...insuredDetails?.flatMap(
        (q1) => {
          //console.log('518',q1)
          return [
            { cardName: q1.relationship, flag: false },
            // {
            //   cardName: `${insured?.relationship} nominee`,
            //   flag: false,
            // },
            // {
            //   cardName: `${insured?.relationship} prev insured`,
            //   flag: false,
            // },
          ];
        },
      ),
      { cardName: 'renewal mandate', flag: false },
    ];
  
}, [dataBuyPolicy]);
  const validate = (values) => {
    let errors = {};
    //console.log('vehicle validation values',values)
    let stateCode = /^([a-zA-Z]){2}?$/;
    let distCode = /^([a-zA-Z0-9]){2}?$/;
    // let uniqueCode = /^([a-zA-Z]){2}?$/;
    let uniqueCode = /^([a-zA-Z])?$/;
    let uniqueNumber = /^([0-9]){4}?$/;
    // if (
    //   values?.businessTypeValue
    //     ?.toLowerCase()
    //     ?.trim()
    //     ?.search('roll over') !== -1
    // ) {
    //   if (
    //     !values?.vehicleRegNo?.part1 ||
    //     !values?.vehicleRegNo?.part2 ||
    //     !values?.vehicleRegNo?.part3 ||
    //     !values?.vehicleRegNo?.part4
    //   ) {
    //     errors.regNo = '* Required';
    //   }
    // }
    // if (
    //   values?.vehicleRegNo?.part1 ||
    //   values?.vehicleRegNo?.part2 ||
    //   values?.vehicleRegNo?.part3 ||
    //   values?.vehicleRegNo?.part4
    // ) {
    //   if (
    //     !values?.vehicleRegNo?.part1 &&
    //     values?.vehicleRegNo?.part2 &&
    //     values?.vehicleRegNo?.part3 &&
    //     values?.vehicleRegNo?.part4
    //   ) {
    //     errors.regNo = '* State Code is Required';
    //   }
    //   if (
    //     values?.vehicleRegNo?.part1 &&
    //     !stateCode.test(values?.vehicleRegNo?.part1)
    //   ) {
    //     errors.regNo = '* Enter valid State or Union Territory Code';
    //   }
    //   if (
    //     !values?.vehicleRegNo?.part2 &&
    //     values?.vehicleRegNo?.part1 &&
    //     values?.vehicleRegNo?.part3 &&
    //     values?.vehicleRegNo?.part4
    //   ) {
    //     errors.regNo = '* District Sequential Number is Required';
    //   }
    //   if (values?.vehicleRegNo?.part2) {
    //     if (!distCode.test(values?.vehicleRegNo?.part2)) {
    //       errors.regNo = '* Enter valid District Sequential Number';
    //     }
    //   }
    //   if (
    //     !values?.vehicleRegNo?.part3 &&
    //     values?.vehicleRegNo?.part1 &&
    //     values?.vehicleRegNo?.part2 &&
    //     values?.vehicleRegNo?.part4
    //   ) {
    //     errors.regNo = '* Unique Code is Required';
    //   }
    //   // if (values?.vehicleRegNo?.part3) {
    //   //   if (!uniqueCode.test(values?.vehicleRegNo?.part3)) {
    //   //     errors.regNo = '* Unique Code cannot be alphanumeric';
    //   //   }
    //   // }
    //   if (
    //     !values?.vehicleRegNo?.part4 &&
    //     values?.vehicleRegNo?.part1 &&
    //     values?.vehicleRegNo?.part2 &&
    //     values?.vehicleRegNo?.part3
    //   ) {
    //     errors.regNo = '* Unique Number is Required';
    //   }
    //   if (values?.vehicleRegNo?.part4) {
    //     if (!uniqueNumber.test(values?.vehicleRegNo?.part4)) {
    //       errors.regNo = '* Unique Number can be only Digits';
    //     }
    //   }
    //   if (
    //     values?.vehicleRegNo?.part1 &&
    //     values?.vehicleRegNo?.part2 &&
    //     values?.vehicleRegNo?.part3 &&
    //     values?.vehicleRegNo?.part4 &&
    //     stateCode.test(values?.vehicleRegNo?.part1) &&
    //     distCode.test(values?.vehicleRegNo?.part2) &&
    //     uniqueCode.test(values?.vehicleRegNo?.part3) &&
    //     uniqueNumber.test(values?.vehicleRegNo?.part4) &&
    //     !values?.isRegNoVerified &&
    //     values?.mode !== 'manual'
    //   ) {
    //     errors.regNo =
    //       '* Click the search icon to fetch the Vehicle Details';
    //   }
    // }
    if(insuredDetails.length !== 0)
    {//console.log('514 _on if')
    insuredDetails.forEach((insured) => {
      //console.log('216_inside for each',insured)
      errors[`${insured.relationship}`] = {};
//       if (!values[`${insured.relationship}`].RegistrationNumber) {
// errors[`${insured.relationship}`].RegistrationNumber = '* Required';
//       }
if (
      !values[`${insured.relationship}`]?.vehicleRegNo?.part1 ||
      !values[`${insured.relationship}`]?.vehicleRegNo?.part2 ||
      !values[`${insured.relationship}`]?.vehicleRegNo?.part3 ||
      !values[`${insured.relationship}`]?.vehicleRegNo?.part4
    ) {
      errors[`${insured.relationship}`].RegistrationNumber = '* Required';
    }if (
      values[`${insured.relationship}`]?.vehicleRegNo?.part1 ||
      values[`${insured.relationship}`]?.vehicleRegNo?.part2 ||
      values[`${insured.relationship}`]?.vehicleRegNo?.part3 ||
      values[`${insured.relationship}`]?.vehicleRegNo?.part4
    ) {
      if (
        !values[`${insured.relationship}`]?.vehicleRegNo?.part1 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part2 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part3 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part4
      ) {
        errors.regNo = '* State Code is Required';
      }
      if (
        values[`${insured.relationship}`]?.vehicleRegNo?.part1 &&
        !stateCode.test(values[`${insured.relationship}`]?.vehicleRegNo?.part1)
      ) {
        errors.regNo = '* Enter valid State or Union Territory Code';
      }
      if (
        !values[`${insured.relationship}`]?.vehicleRegNo?.part2 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part1 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part3 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part4
      ) {
        errors.regNo = '* District Sequential Number is Required';
      }
      if (values[`${insured.relationship}`]?.vehicleRegNo?.part2) {
        if (!distCode.test(values[`${insured.relationship}`]?.vehicleRegNo?.part2)) {
          errors.regNo = '* Enter valid District Sequential Number';
        }
      }
      if (
        !values[`${insured.relationship}`]?.vehicleRegNo?.part3 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part1 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part2 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part4
      ) {
        errors.regNo = '* Unique Code is Required';
      }
      if (values[`${insured.relationship}`]?.vehicleRegNo?.part3) {
        if (!uniqueCode.test(values[`${insured.relationship}`]?.vehicleRegNo?.part3)) {
          errors.regNo = '* Unique Code cannot be alphanumeric';
        }
      }
      if (
        !values[`${insured.relationship}`]?.vehicleRegNo?.part4 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part1 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part2 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part3
      ) {
        errors.regNo = '* Unique Number is Required';
      }
      if (values[`${insured.relationship}`]?.vehicleRegNo?.part4) {
        if (!uniqueNumber.test(values[`${insured.relationship}`]?.vehicleRegNo?.part4)) {
          errors.regNo = '* Unique Number can be only Digits';
        }
      }
      if (
        values[`${insured.relationship}`]?.vehicleRegNo?.part1 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part2 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part3 &&
        values[`${insured.relationship}`]?.vehicleRegNo?.part4 &&
        stateCode.test(values[`${insured.relationship}`]?.vehicleRegNo?.part1) &&
        distCode.test(values[`${insured.relationship}`]?.vehicleRegNo?.part2) &&
        uniqueCode.test(values[`${insured.relationship}`]?.vehicleRegNo?.part3) &&
        uniqueNumber.test(values[`${insured.relationship}`]?.vehicleRegNo?.part4) &&
        !values?.isRegNoVerified &&
        values?.mode !== 'manual'
      ) {
        errors.regNo =
          '* Click the search icon to fetch the Vehicle Details';
      }
    }
      if (values[`${insured.relationship}`].ChasisNo !== null) {
      if(values[`${insured.relationship}`].ChasisNo?.length < 17)
      {
        errors[`${insured.relationship}`].ChasisNo = '* Minimum 17 characters Required';
      }
      }
      if(quoteData?.quotationType?.toLowerCase() ===
      'new business'){
      if (!values[`${insured.relationship}`].EngineNo) {
        errors[`${insured.relationship}`].EngineNo = '* Required';
      }
      if (!values[`${insured.relationship}`].ChasisNo) {
        errors[`${insured.relationship}`].ChasisNo = '* Required';
      }
    }
    })
    }
    
    let error_count = 0;
    if(insuredDetails.length !== 0)
    {
    insuredDetails.forEach((insured) => {
      error_count += Object.keys(errors[`${insured.relationship}`])
        .length;
    });
    }
    
    if (error_count === 0) {
      errors = {};
    }
     //console.log('error data',errors)
    return errors;
  };
  
  // const VehicleDetailsForm = ({ validate }) => {
  //   const { values } = useQuantaFormikContext();
  //   const [previousRegNoValues, setPreviousPartValues] = useState({
  //     part1: '',
  //     part2: '',
  //     part3: '',
  //     part4: '',
  //   });
  //   const data = [
  //     {
  //       title: 'Vehicle Registration',
  //       grid_data: [
          
  //         // {
  //         //   type: 'render',
  //         //   colSpan: repeat === repeatForMobile ? 2 : 1,
  //         //   component: (_) => {
  //         //     return (
  //         //       <>
  //         //         {buyMotorPolicy?.quoteData?.regNo ||
  //         //         values?.vehicleRegistrationDetails?.isNewVehicle ? (
  //         //           <Label
  //         //             text={'Registration Number'}
  //         //             severity={'info'}
  //         //             type={'label'}
  //         //           >
  //         //             {
  //         //               values?.vehicleRegistrationDetails
  //         //                 ?.registrationNumber
  //         //             }
  //         //           </Label>
  //         //         ) : (
  //         //           <QuantaInputWrapper
  //         //             label={<>
  //         //               <Text type={'label'}>Registration Number</Text>
  //         //               <Text severity="error"> *</Text>
  //         //             </>}
  //         //             name="vehicleRegistrationDetails.registrationNumber"
  //         //             size="full"
  //         //             disabled = {buyMotorPolicy?.proposalNumber?.length>0}
  //         //             className={buyMotorPolicy?.proposalNumber?.length>0?`border-neutral-dark`:``}
  //         //             fields={[
  //         //               'vehicleRegistrationDetails.registrationNumberParts.part1',
  //         //               'vehicleRegistrationDetails.registrationNumberParts.part2',
  //         //               'vehicleRegistrationDetails.registrationNumberParts.part3',
  //         //               'vehicleRegistrationDetails.registrationNumberParts.part4',
  //         //             ]}
  //         //           >
  //         //             <QuantaInput
  //         //               name="vehicleRegistrationDetails.registrationNumberParts.part1"
  //         //               maxLength="2"
  //         //               size="full"
  //         //               type="text"
  //         //               placeholder="MH"
  //         //               noerror
  //         //               className="uppercase"
  //         //               disabled = {buyMotorPolicy?.proposalNumber?.length>0}
  //         //               onKeyUp={(e) => {
  //         //                 if (e.target.value.length === 2) {
  //         //                   document
  //         //                     .getElementsByName(
  //         //                       'vehicleRegistrationDetails.registrationNumberParts.part2',
  //         //                     )
  //         //                     .forEach((e) => e.focus());
  //         //                 }
  //         //               }}
  //         //               onDataChange={(val, setFieldValue) => {
  //         //                 setFieldValue(
  //         //                   `vehicleRegistrationDetails.registrationNumberParts.part1`,
  //         //                   val?.toString()?.toUpperCase(),
  //         //                 );
  //         //               }}
  //         //             />
  //         //             <span className={`flex items-center font-bold h-12 ${buyMotorPolicy?.proposalNumber?.length>0?'bg-neutral-light opacity-50':''}`}>
  //         //               -
  //         //             </span>
  //         //             <QuantaInput
  //         //               name="vehicleRegistrationDetails.registrationNumberParts.part2"
  //         //               maxLength="2"
  //         //               size="full"
  //         //               type="text"
  //         //               placeholder="01"
  //         //               noerror
  //         //               disabled = {buyMotorPolicy?.proposalNumber?.length>0}
  //         //               onKeyUp={(e) => {
  //         //                 if (e.target.value.length === 2) {
  //         //                   document
  //         //                     .getElementsByName(
  //         //                       'vehicleRegistrationDetails.registrationNumberParts.part3',
  //         //                     )
  //         //                     .forEach((e) => e.focus());
  //         //                 }
  //         //               }}
  //         //             />
  //         //             <span className={`flex items-center font-bold h-12 ${buyMotorPolicy?.proposalNumber?.length>0?'bg-neutral-light opacity-50':''}`}>
  //         //               -
  //         //             </span>
  //         //             <QuantaInput
  //         //               name="vehicleRegistrationDetails.registrationNumberParts.part3"
  //         //               maxLength="2"
  //         //               size="full"
  //         //               type="text"
  //         //               placeholder="CR"
  //         //               noerror
  //         //               className="uppercase"
  //         //               disabled = {buyMotorPolicy?.proposalNumber?.length>0}
  //         //               onKeyUp={(e) => {
  //         //                 if (e.target.value.length === 2) {
  //         //                   document
  //         //                     .getElementsByName(
  //         //                       'vehicleRegistrationDetails.registrationNumberParts.part4',
  //         //                     )
  //         //                     .forEach((e) => e.focus());
  //         //                 }
  //         //               }}
  //         //               onDataChange={(val, setFieldValue) => {
  //         //                 setFieldValue(
  //         //                   `vehicleRegistrationDetails.registrationNumberParts.part3`,
  //         //                   val?.toString()?.toUpperCase(),
  //         //                 );
  //         //               }}
  //         //             />
  //         //             <span className={`flex items-center font-bold h-12 ${buyMotorPolicy?.proposalNumber?.length>0?'bg-neutral-light opacity-50':''}`}>
  //         //               -
  //         //             </span>
  //         //             <QuantaInput
  //         //               name="vehicleRegistrationDetails.registrationNumberParts.part4"
  //         //               maxLength="4"
  //         //               size="full"
  //         //               type="text"
  //         //               placeholder="2845"
  //         //               disabled = {buyMotorPolicy?.proposalNumber?.length>0}
  //         //               noerror
  //         //             />
  //         //           </QuantaInputWrapper>
  //         //         )}
  //         //       </>
  //         //     );
  //         //   },
  //         // },
  //         // !buyMotorPolicy?.quoteData?.regNo
  //         //   ? {
  //         //       type: 'render',
  //         //       colSpan: 2,
  //         //       component: (_) => {
  //         //         return (
  //         //           <Text className="flex flex-col justify-center h-full">
  //         //             <Text>
  //         //               <QuantaCheckbox
  //         //                 name={
  //         //                   'vehicleRegistrationDetails.isNewVehicle'
  //         //                 }
  //         //                 label={'New Vehicle'}
  //         //                 disabled={buyMotorPolicy?.proposalNumber?.length>0}
  //         //                 onDataChange={(val, setFieldValue) => {
  //         //                   if (val) {
  //         //                     setPreviousPartValues({
  //         //                       ...values?.vehicleRegistrationDetails
  //         //                         ?.registrationNumberParts,
  //         //                     });
  //         //                   }
  //         //                   setFieldValue(
  //         //                     `vehicleRegistrationDetails.registrationNumber`,
  //         //                     val ? 'NEW' : '',
  //         //                   );
  //         //                   setFieldValue(
  //         //                     `vehicleRegistrationDetails.registrationNumberParts`,
  //         //                     {
  //         //                       part1: val
  //         //                         ? ''
  //         //                         : previousRegNoValues?.part1,
  //         //                       part2: val
  //         //                         ? ''
  //         //                         : previousRegNoValues?.part2,
  //         //                       part3: val
  //         //                         ? ''
  //         //                         : previousRegNoValues?.part3,
  //         //                       part4: val
  //         //                         ? ''
  //         //                         : previousRegNoValues?.part4,
  //         //                     },
  //         //                   );
  //         //                 }}
  //         //               />
  //         //             </Text>
  //         //           </Text>
  //         //         );
  //         //       },
  //         //     }
  //         //   : null,
  //         // {
  //         //   type: 'checkbox',
  //         //   name: 'vehicleRegistrationDetails.isNewVehicle',
  //         //   label: 'New Vehicle',
  //         //   colSpan: repeat === repeatForDesktop ? 2:1,
  //         //   onDataChange: (val,setFieldValue) => {
  //         //     setFieldValue(`vehicleRegistrationDetails.registrationNumber`,val?'NEW':'');
  //         //     setFieldValue(`vehicleRegistrationDetails.registrationNumberParts`,{
  //         //       part1: '',
  //         //       part2: '',
  //         //       part3: '',
  //         //       part4: ''
  //         //     });
  //         //   }
  //         // }:null,
  //         {
  //           type: 'text',
  //           disabled: true,
  //           //colSpan: repeat === repeatForMobile ? 2 : 1,
  //           name: 'vehicleRegistrationDetails.engineNumber',
  //           label: (<>
  //                   <Text type={'label'}>Engine Number</Text>
  //                   <Text severity="error"> *</Text>
  //                 </>
  //           ),
  //           data : quoteData?.VehicleType[0]
  //         },
  //         {
  //           type: 'text',
  //           disabled: buyMotorPolicy?.proposalNumber?.length>0,
  //           //colSpan: repeat === repeatForMobile ? 2 : 1,
  //           name: 'vehicleRegistrationDetails.engineNumber',
  //           label: (<>
  //                   <Text type={'label'}>Engine Number</Text>
  //                   <Text severity="error"> *</Text>
  //                 </>
  //           ),
  //         },
  //         {
  //           type: 'text',
  //           disabled: buyMotorPolicy?.proposalNumber?.length>0,
  //           //colSpan: repeat === repeatForMobile ? 2 : 1,
  //           name: 'vehicleRegistrationDetails.engineNumber',
  //           label: (<>
  //                   <Text type={'label'}>Reg Number</Text>
  //                   <Text severity="error"> *</Text>
  //                 </>
  //           ),
  //         },
  //         {
  //           type: 'text',
  //           disabled: buyMotorPolicy?.proposalNumber?.length>0,
  //           //colSpan: repeat === repeatForMobile ? 2 : 1,
  //           name: 'vehicleRegistrationDetails.chasisNumber',
  //           label: (<>
  //                   <Text type={'label'}>Chassis Number</Text>
  //                   <Text severity="error"> *</Text>
  //                 </>
  //           ),
  //         },
  //         {
  //           type: 'text',
  //           disabled: buyMotorPolicy?.proposalNumber?.length>0,
  //           //colSpan: repeat === repeatForMobile ? 2 : 1,
  //           name: 'vehicleRegistrationDetails.make',
  //           label: (<>
  //                   <Text type={'label'}>make</Text>
  //                   <Text severity="error"> *</Text>
  //                 </>
  //           ),
  //         },
  //         {
  //           type: 'text',
  //           disabled: buyMotorPolicy?.proposalNumber?.length>0,
  //           //colSpan: repeat === repeatForMobile ? 2 : 1,
  //           name: 'vehicleRegistrationDetails.model',
  //           label: (<>
  //                   <Text type={'label'}>model</Text>
  //                   <Text severity="error"> *</Text>
  //                 </>
  //           ),
  //         },
  //         <hr />
  //       ].filter((d) => d),
  //     },
  //     // {
  //     //   title: 'Vehicle Details',
  //     //   grid_type: 'data',
  //     //   grid_data: [
  //     //     {
  //     //       label: <>Make</>,

  //     //       text: <Text>{values?.vehicleDetails?.make?.value}</Text>,
  //     //     },
  //     //     {
  //     //       label: <>Model</>,

  //     //       text: <Text>{values?.vehicleDetails?.model?.value}</Text>,
  //     //     },
  //     //     {
  //     //       label: <>Variant</>,

  //     //       text: (
  //     //         <Text>{values?.vehicleDetails?.variant?.value}</Text>
  //     //       ),
  //     //     },
  //     //     {
  //     //       label: <>Fuel Type</>,
  //     //       text: <Text>{values?.vehicleDetails?.fuelType}</Text>,
  //     //     },
  //     //     {
  //     //       label: <>Cubic Capacity</>,
  //     //       text: <Text>{values?.vehicleDetails?.cubeCapacity}</Text>,
  //     //     },
  //     //     {
  //     //       label: <>Seating Capacity</>,
  //     //       text: (
  //     //         <Text>{values?.vehicleDetails?.seatingCapacity}</Text>
  //     //       ),
  //     //     },
  //     //     {
  //     //       label: <>Year of Manufacture</>,
  //     //       text: (
  //     //         <Text>{values?.vehicleDetails?.yearOfManufacture}</Text>
  //     //       ),
  //     //     },

  //     //     {
  //     //       label: <>RTO Code (Location)</>,
  //     //       text: (
  //     //         <Text>{`${
  //     //           values?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
  //     //         }${
  //     //           values?.vehicleDetails?.rtoDetails
  //     //             ?.rtoAuthorityCode &&
  //     //           values?.vehicleDetails?.rtoDetails?.rtoLocationDesc
  //     //             ? '-'
  //     //             : ''
  //     //         }${
  //     //           values?.vehicleDetails?.rtoDetails?.rtoLocationDesc
  //     //         }`}</Text>
  //     //       ),
  //     //     },
  //     //     {
  //     //       label: <>Date of Registration/Invoice</>,
  //     //       text: (
  //     //         <Text>
  //     //           {values?.vehicleDetails?.dateOfRegistration}
  //     //         </Text>
  //     //       ),
  //     //     },
  //     //   ],
  //     // },
  //     // {
  //     //   title: 'Insured Declared Value',
  //     //   grid_type: 'data',
  //     //   grid_data: [
  //     //     {
  //     //       label: <>Vehicle IDV</>,
  //     //       text: (
  //     //         <Text>
  //     //           {CurrencyFormater(
  //     //             `${values?.insuredDeclaredDetails?.vehicleIDV}`,
  //     //           )}
  //     //         </Text>
  //     //       ),
  //     //     },
  //     //     {
  //     //       label: <>IRF1 Adjustment</>,
  //     //       text: values?.insuredDeclaredDetails
  //     //         ?.irfAdjustmentPercent ? (
  //     //         <Text>{`${values?.insuredDeclaredDetails?.irfAdjustmentPercent} %`}</Text>
  //     //       ) : (
  //     //         ''
  //     //       ),
  //     //     },
  //     //   ],
  //     // },
  //   ];
 
  //   const other_props = {
  //     flow: 'cols',
  //     repeat,
  //     gapX: 6,
  //     gapY: 0,
  //     spaceY: 2,
  //     size: 'full',
  //     titleSeverity: 'info',
  //   };

  //   return (
  //     <>
  //       <QuantaForm className="space-y-4 mt-3">
  //         <MixedGridGroup {...{ data, ...other_props }} />
  //       </QuantaForm>
  //     </>
  //   );
  // };
  const InsuredMemberForm = ({ validate }) => {
    
    const { values, setFieldValue } = useQuantaFormikContext();
   
    
    let data = insuredDetails?.map((m, idx) => {
      //console.log('insuredDetails ',insuredDetails);
      //console.log(`1087.... ${idx} : m : ${m.relationship}`);
      getRtoDetails()
      getRtoDetails1()
      getRtoDetails2()
      getRtoDetails3()
      getRtoDetails4()
      
          return {
            
            title: (
              <>
                <Text severity="info" type="large">
                  {m.relationship}{' '}
                
                </Text>
                <Text severity="error" type="title">
                  *
                </Text>
              </>
            ),
            size: 'medium',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                `${m.relationship?.toString()?.toLowerCase()}`,
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    `${m.relationship?.toString()?.toLowerCase()}`,
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      `${m.relationship?.toString()?.toLowerCase()}`,
                  ),
                  flag: expanded,
                },
              ];
            },
            
            grid_data: [
              
              
              // {
              //   type: 'text',
              //   label: (
              //     <div>
              //       Registration Number <Text severity="error">*</Text>
              //     </div>
              //   ),
                
              //   name: `${m.relationship}.RegistrationNumber`
              // },
              {
                type: 'input-wrapper',
                size: 'full',
                fields: [
                  `${m.relationship}.vehicleRegNo.part1`,
                  `${m.relationship}.vehicleRegNo.part2`,
                  `${m.relationship}.vehicleRegNo.part3`,
                  `${m.relationship}.vehicleRegNo.part4`,
                ],
                // disabled:
                //   values?.quotationNo !== '' || loadingBusinessType,
                className: `${
                  values?.quotationNo !== '' ||
                    loadingBusinessType ||
                    loadingVehicleDetials
                    ? 'border-neutral-dark'
                    : ''
                  }`,
                children: (
                  <>
                    <QuantaInput
                      name={`${m.relationship}.vehicleRegNo.part1`}
                      maxLength="2"
                      size="full"
                      type="text"
                      placeholder="MH"
                      noerror
                      className="uppercase"
                      // disabled={
                      //   values?.quotationNo !== '' 
                      //   // ||
                      //   // loadingVehicleDetials ||
                      //   // loadingBusinessType
                      // }
                      onKeyUp={(e) => {
                        if (e.target.value.length === 2) {
                          document
                            .getElementsByName(`${m.relationship}.vehicleRegNo.part2`)
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values[`${m.relationship}`];
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        if (
                          key === 'Enter' &&
                          (validate(values)[`${m.relationship}`].RegistrationNumber ===
                            '* Click the search icon to fetch the Vehicle Details' ||
                            !validate(values)[`${m.relationship}`].RegistrationNumber) &&
                          part1?.length === 2 &&
                          part2?.length === 2 &&
                          // part3?.length === 2 &&
                          part3?.length === 2 &&
                          part4?.length === 4
                        ) {
                          onFLALookup({ values, setFieldValue });
                        }
                      }}
                      onDataChange={(val, setFieldValue) => {
                        setFieldValue(
                          `${m.relationship}.vehicleRegNo.part1`,
                          val?.toString()?.toUpperCase(),
                        );
                        setFieldValue(`${m.relationship}.isRegNoVerified`, null);
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        values?.quotationNo !== '' 
                        // ||
                        //   loadingVehicleDetials ||
                        //   loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                        } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name={`${m.relationship}.vehicleRegNo.part2`}
                      maxLength="2"
                      size="full"
                      type="text"
                      placeholder="01"
                      noerror
                      // disabled={
                      //   values?.quotationNo !== '' 
                      //   // ||
                      //   // loadingVehicleDetials ||
                      //   // loadingBusinessType
                      // }
                      onDataChange={(_) =>
                        setFieldValue(`${m.relationship}.isRegNoVerified`, null)
                      }
                      onKeyUp={(e) => {
                        if (e.target.value.length === 2) {
                          document
                            .getElementsByName(`${m.relationship}.vehicleRegNo.part3`)
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values[`${m.relationship}`]
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        if (
                          key === 'Enter' &&
                          (validate(values)[`${m.relationship}`].RegistrationNumber ===
                            '* Click the search icon to fetch the Vehicle Details' ||
                            !validate(values)[`${m.relationship}`].RegistrationNumber) &&
                          part1?.length === 2 &&
                          part2?.length === 2 &&
                          // part3?.length === 2 &&
                          part3?.length === 2 &&
                          part4?.length === 4
                        ) {
                          onFLALookup({ values, setFieldValue });
                        }
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        values?.quotationNo !== '' 
                        // ||
                        //   loadingVehicleDetials ||
                        //   loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                        } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name={`${m.relationship}.vehicleRegNo.part3`}
                      maxLength="2"
                      size="full"
                      type="text"
                      placeholder="CR"
                      noerror
                      className="uppercase"
                      // disabled={
                      //   values?.quotationNo !== '' 
                      //   // ||
                      //   // loadingVehicleDetials ||
                      //   // loadingBusinessType
                      // }
                      onKeyUp={(e) => {
                        if (e.target.value.length === 2) {
                          document
                            .getElementsByName(`${m.relationship}.vehicleRegNo.part4`)
                            .forEach((e) => e.focus());
                        }
                      }}
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values[`${m.relationship}`]
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        if (
                          key === 'Enter' &&
                          (validate(values)[`${m.relationship}`].RegistrationNumber ===
                            '* Click the search icon to fetch the Vehicle Details' ||
                            !validate(values)[`${m.relationship}`].RegistrationNumber) &&
                          part1?.length === 2 &&
                          part2?.length === 2 &&
                          part3?.length === 2 &&
                          part4?.length === 4
                        ) {
                          onFLALookup({ values, setFieldValue });
                        }
                      }}
                      onDataChange={(val, setFieldValue) => {
                        setFieldValue(
                          `${m.relationship}.vehicleRegNo.part3`,
                          val?.toString()?.toUpperCase(),
                        );
                        setFieldValue(`${m.relationship}.isRegNoVerified`, null);
                      }}
                    />
                    <span
                      className={`flex items-center font-bold ${
                        values?.quotationNo !== '' 
                        // ||
                        //   loadingVehicleDetials ||
                        //   loadingBusinessType
                          ? 'bg-neutral-light'
                          : ''
                        } h-12`}
                    >
                      -
                    </span>
                    <QuantaInput
                      name={`${m.relationship}.vehicleRegNo.part4`}
                      maxLength="4"
                      size="full"
                      type="text"
                      placeholder="2845"
                      // disabled={
                      //   values?.quotationNo !== '' 
                      //   // ||
                      //   // loadingVehicleDetials ||
                      //   // loadingBusinessType
                      // }
                      onDataChange={(_) =>
                        setFieldValue(`isRegNoVerified`, null)
                      }
                      onKeyDown={({ key }) => {
                        const { vehicleRegNo } = values[`${m.relationship}`]
                        const { part1, part2, part3, part4 } =
                          vehicleRegNo;
                        if (
                          key === 'Enter' &&
                          (validate(values)[`${m.relationship}`].RegistrationNumber ===
                            '* Click the search icon to fetch the Vehicle Details' ||
                            !validate(values)[`${m.relationship}`].RegistrationNumber) &&
                          part1?.length === 2 &&
                          part2?.length === 2 &&
                          part3?.length === 2 &&
                          part4?.length === 4
                        ) {
                          onFLALookup({ values, setFieldValue });
                        }
                      }}
                      noerror
                    />
                    <QuantaButton
                      type="button"
                      className="w-32"
                      // disabled={
                      //   values?.quotationNo !== '' 
                      //   // ||
                      //   // loadingVehicleDetials ||
                      //   // loadingBusinessType
                      // }
                      onClick={async ({
                        values ,
                        isValid,
                        setFieldValue,
                      }) => {
                        const data = values[`${m.relationship}`]
                        ////console.log('values',values)
                        //console.log('data',data)
                        const FLA = onFLALookup( data,`${m.relationship}`,setFieldValue, );
                        //console.log('FLA output',FLA)
                        if(FLA === 1)
                        {
                          //console.log('on if error')
                        }
                        else{
                          //console.log('on else')
                        }
                      }}
                    >
                      {loadingVehicleDetials ?
                    <FontAwesomeIcon icon={faSpinner} spin={true}/>
                  :<FontAwesomeIcon icon={faSearch} />}
                  
                    </QuantaButton>
                  </>
                ),
                label: (
                  <>
                    Registration Number
                    <Text severity="error">*</Text>
                  </>
                ),
                name: `${m.relationship}.RegistrationNumber`,
                // colSpan: repeat,
              },
              // {
              //   type: 'text',
              //   label: (
              //     <div>
              //       FLA Output <Text severity="error">*</Text>
              //     </div>
              //   ),
                
              //   name: `${m.relationship}.fla`

              // },
              {
                type: 'render',
                colSpan:
                  repeat === repeatForMobile ? repeat_for_mobile : 2,
                component: () => (
                  <Text
                    className={
                      repeat === repeatForMobile
                        ? 'flex items-baseline -mt-2'
                        : 'flex mt-8 items-center'
                    }
                  >
                    { values[`${m.relationship}`]?.isRegNoVerified === false ? (
                      <Text className={`flex gap-2 justify-start w-full`}>
                        <Text severity={'error'}>
                          <FontAwesomeIcon icon={faExclamation} />
                        </Text>
                        <Text severity="error">
                          We couldn't find any vehicle for input
                          registration number, please enter manually
                        </Text>
                      </Text>
                    ):null}
                    {values[`${m.relationship}`]?.isRegNoVerified === true ? (
                      <Text
                        className={`flex gap-2 justify-start w-full ${
                          repeat === repeatForMobile ? 'my-1' : ''
                          }`}
                      >
                        <Text severity={'success'}>
                          <FontAwesomeIcon icon={faCheck} />
                        </Text>
                        <Text>
                          We have found below Vehicle details for your
                          input registration number
                        </Text>
                      </Text>
                    ):null}
                  </Text>
                ),
              },
              
              {
                type: 'select',
                label: (
                  <div>
                    Vehicle Make <Text></Text>
                  </div>
                ),
                disabled:values[`${m.relationship}`].isRegNoVerified,
                //name: `${quoteData.VehicleType[idx]}.middleName`,
                name: `${m.relationship}.VehicleMake`,
                searchable : true,
                data: quoteData.members?.[idx]?.relationship?.toString() === 'Two Wheeler' ?
                
                makeList?.map((v) => {
                  return {
                    label: v?.value ? v?.value : '',
                    value: v?.value ? v?.value : '',
                  };
                })
                : quoteData.members?.[idx]?.relationship?.toString() === 'Private Car' ?
                makeList1?.map((v) => {
                  return {
                    label: v?.value ? v?.value : '',
                    value: v?.value ? v?.value : '',
                  };
                }) 
                : quoteData.members?.[idx]?.relationship?.toString() === 'GCV' ?
                makeList2?.map((v) => {
                  return {
                    label: v?.value ? v?.value : '',
                    value: v?.value ? v?.value : '',
                  };
                }): quoteData.members?.[idx]?.relationship?.toString() === 'PCV' ?
                makeList3?.map((v) => {
                  return {
                    label: v?.value ? v?.value : '',
                    value: v?.value ? v?.value : '',
                  };
                }) : quoteData.members?.[idx]?.relationship?.toString() === 'Misc. D' ?
                makeList4?.map((v) => {
                  return {
                    label: v?.value ? v?.value : '',
                    value: v?.value ? v?.value : '',
                  };
                }):null
                ,
                onDataChange: quoteData.members?.[idx]?.relationship?.toString() === 'Two Wheeler' ?
                async (val, setFieldValue) => {
                  await onBrandSelected(val);
                 }
                 : quoteData.members?.[idx]?.relationship?.toString() === 'Private Car' ?
                 async (val, setFieldValue) => {
                  await onBrandSelected1(val);
                 }
                 : quoteData.members?.[idx]?.relationship?.toString() === 'GCV' ?
                 async (val, setFieldValue) => {
                  await onBrandSelected2(val);
                 } : quoteData.members?.[idx]?.relationship?.toString() === 'PCV' ?
                 async (val, setFieldValue) => {
                  await onBrandSelected3(val);
                 } : quoteData.members?.[idx]?.relationship?.toString() === 'Misc. D' ?
                 async (val, setFieldValue) => {
                  await onBrandSelected4(val);
                 } : null
              },
              {
                type: 'select',
                label: (
                  <div>
                    Vehicle Model
                  </div>
                ),
                name: `${m.relationship}.VehicleModel`,
                disabled:values[`${m.relationship}`].isRegNoVerified,
                searchable : true,
               // disabled: buyHealthPolicy?.proposalNumber.length > 0,
               data:quoteData.members?.[idx]?.relationship?.toString() === 'Two Wheeler' ?
               modelList?.map((c) => {
                return {
                  label: c?.value
                    ? c?.value
                    : '',
                  value: c?.value
                    ? c?.value
                    : '',
                };
              })
                   : quoteData.members?.[idx]?.relationship?.toString() === 'Private Car' ?
                   modelList1?.map((c) => {
                    return {
                      label: c?.value
                        ? c?.value
                        : '',
                      value: c?.value
                        ? c?.value
                        : '',
                    };
                  })
                  : quoteData.members?.[idx]?.relationship?.toString() === 'GCV' ?
                   modelList2?.map((c) => {
                    return {
                      label: c?.value
                        ? c?.value
                        : '',
                      value: c?.value
                        ? c?.value
                        : '',
                    };
                  })
                  : quoteData.members?.[idx]?.relationship?.toString() === 'PCV' ?
                   modelList3?.map((c) => {
                    return {
                      label: c?.value
                        ? c?.value
                        : '',
                      value: c?.value
                        ? c?.value
                        : '',
                    };
                  })
                  : quoteData.members?.[idx]?.relationship?.toString() === 'Misc. D' ?
                   modelList4?.map((c) => {
                    return {
                      label: c?.value
                        ? c?.value
                        : '',
                      value: c?.value
                        ? c?.value
                        : '',
                    };
                  })
                  :null
                  ,
              },
              {
                type: 'text',
                label: (
                  <div>
                    Engine Number 
                  </div>
                ),
                name: `${m.relationship}.EngineNo`,
                disabled:values[`${m.relationship}`].isRegNoVerified,
               // disabled: buyHealthPolicy?.proposalNumber.length > 0,
               
              },
              {
                type: 'text',
                label: (
                  <div>
                    Chassis Number 
                  </div>
                ),
                name: `${m.relationship}.ChasisNo`,
                disabled:values[`${m.relationship}`].isRegNoVerified,
               // disabled: buyHealthPolicy?.proposalNumber.length > 0,
               
              },
              
              
              
            
              
            ].filter((d) => d),
          };
        })
      ;

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };

    return (
      <>
        <QuantaForm className="space-y-4 mt-3">
          <InputGridGroup {...{ data, ...other_props }} />
        </QuantaForm>
      </>
    );
  };
  // const onSubmit = (values) => {
  //   //console.log('1297_values_Data',values)
  //   const v = getVehicleData(values)
  //   console.log('1312_values_Data',v)
  //   updateBuyMotorPolicy({
  //     vehicleTabDetails: {
  //       ...values,
  //       vehicleRegistrationDetails: {
  //         v
  //         //...values?.vehicleRegistrationDetails,
  //         //registrationNumber: values?.vehicleRegistrationDetails?.registrationNumber === 'NEW'?'NEW':`${values?.vehicleRegistrationDetails?.registrationNumberParts?.part1}${values?.vehicleRegistrationDetails?.registrationNumberParts?.part2}${values?.vehicleRegistrationDetails?.registrationNumberParts?.part3}${values?.vehicleRegistrationDetails?.registrationNumberParts?.part4}`,
  //       },
  //     },
  //   });
  //   return true;
  // };
  const getVehicleData =  (values) =>
    {
      let submitArr = [];
    Object.keys(values).forEach((m) => {
      if(m.toString() !== 'isRegNoVerified')
      {
      submitArr.push({
        relationship: m,
        ...values[m],
        
      });
    }
    });
    return submitArr ;
        if(false)//quoteData.VehicleType.length === 1)
        {
          arr.push( {
            VehicleType : quoteData.VehicleType,
            RegistrationNumber : values.RegistrationNumber,
            VehicleMakeModel :values.VehicleMake+'-'+ values.VehicleModel,
            EngineNo : values.EngineNo,
            ChasisNo : values.ChasisNo,
          });
        }
        else if(false)
        {
          arr.push( {
            VehicleType : quoteData.VehicleType[i],
            RegistrationNumber : values.RegistrationNumber[i],
            VehicleMakeModel :values.VehicleMake[i]+'-'+ values.VehicleModel[i],
            EngineNo : values.EngineNo[i],
            ChasisNo : values.ChasisNo[i],
          });
        }
      
       // return arr
      //arr = Object.keys(values).arr;
      //return {insuredDetails : arr};
    }
    
  const onSubmit = (values) => {
  
    if (Object.values(validate(values)).length === 0) {

      setParentAlerts([]);
      setProceedToNextStep([
        proceedToNextStep[0],
        true,
        ...proceedToNextStep.slice(2),
      ]);
    
      //updateBuyHealthPolicy({{insuredDetails : arr}}getVehicleData(values));
      updateBuyHealthPolicy(
        {
        insuredDetails:getVehicleData(values),
      })
      return true;
    }
    //const vehicleTabDetails = getVehicleData(values)
    //updateBuyHealthPolicy({...values,insuredDetails:getVehicleData(values),});
    //updateBuyHealthPolicy({insuredDetails:getVehicleData(values)})
      //return true;
  return false
  };
  
  return (
    <div>
      <QuantaFormik
        innerRef={props.forwardedRef}
        enableReinitialize={true}
        {...{
          initialValues,
          validate,
          onSubmit,
          validator: () => ({}),
        }}
      >
        {/* <VehicleDetailsForm {...{ validate }} /> */}
        <InsuredMemberForm {...{ validate }} />
      </QuantaFormik>
    </div>
  );
}
